import { application } from "../application"
import BackToTopController from "./back_to_top_controller"
import BrandSearchController from "./brand_search_controller"
import ButtonGroupController from "./button_group_controller"
import CartController from "./cart_controller"
import CartCountdownController from "./cart_countdown_controller"
import CartExtensionController from "./cart_extension_controller"
import CarouselController from "./carousel_controller"
import CatalogController from "./catalog_controller"
import CatalogFrameController from "./catalog_frame_controller"
import CatalogFiltersController from "./catalog_filters_controller"
import CembrapayDataController from "./cembrapay_data_controller"
import ContactController from "./contact_controller"
import DisclosureController from "./disclosure_controller"
import DismissibleController from "./dismissible_controller"
import DeliveryAddressController from "./delivery_address_controller"
import DeliveryMethodController from "./delivery_method_controller"
import DropdownSelectController from "./dropdown_select_controller"
import FaqSearchController from "./faq_search_controller"
import FrequencyController from "./frequency_controller"
import HeaderController from "./header_controller"
import HeaderMenuController from "./header_menu_controller"
import InviteController from "./invite_controller"
import MarkdownController from "./markdown_controller"
import ModalController from "./modal_controller"
import ModalTriggerController from "./modal_trigger_controller"
import NewsletterPromptController from "./newsletter_prompt_controller"
import OrdersLiveController from "./orders_live_controller"
import PageMenuController from "./page_menu_controller"
import PaymentFormController from "./payment_form_controller"
import PaymentWaitController from "./payment_wait_controller"
import PickpostController from "./pickpost_controller"
import PopoverController from "./popover_controller"
import PopperController from "./popper_controller"
import ProductBuyBoxController from "./product_buy_box_controller"
import ProductCoverController from "./product_cover_controller"
import ProductDescriptionController from "./product_description_controller"
import ProductGalleryController from "./product_gallery_controller"
import ProductHoverController from "./product_hover_controller"
import ProductPageController from "./product_page_controller"
import ProductShareController from "./product_share_controller"
import ProductThumbnailsController from "./product_thumbnails_controller"
import QuickShopController from "./quick_shop_controller"
import RemoteFormController from "./remote_form_controller"
import ReturnSlipController from "./return_slip_controller"
import SaleAlertController from "./sale_alert_controller"
import SaleListController from "./sale_list_controller"
import SaleMenuController from "./sale_menu_controller"
import SalePageController from "./sale_page_controller"
import TemporaryNoticeController from "./temporary_notice_controller"
import TooltipController from "./tooltip_controller"
import ZendeskController from "./zendesk_controller"

application.register("website--back-to-top", BackToTopController)
application.register("website--brand-search", BrandSearchController)
application.register("website--button-group", ButtonGroupController)
application.register("website--cart", CartController)
application.register("website--cart-countdown", CartCountdownController)
application.register("website--cart-extension", CartExtensionController)
application.register("website--carousel", CarouselController)
application.register("website--catalog", CatalogController)
application.register("website--catalog-frame", CatalogFrameController)
application.register("website--catalog-filters", CatalogFiltersController)
application.register("website--cembrapay-data", CembrapayDataController)
application.register("website--contact", ContactController)
application.register("website--disclosure", DisclosureController)
application.register("website--dismissible", DismissibleController)
application.register("website--delivery-address", DeliveryAddressController)
application.register("website--delivery-method", DeliveryMethodController)
application.register("website--dropdown-select", DropdownSelectController)
application.register("website--faq-search", FaqSearchController)
application.register("website--frequency", FrequencyController)
application.register("website--header", HeaderController)
application.register("website--header-menu", HeaderMenuController)
application.register("website--invite", InviteController)
application.register("website--markdown", MarkdownController)
application.register("website--modal", ModalController)
application.register("website--modal-trigger", ModalTriggerController)
application.register("website--newsletter-prompt", NewsletterPromptController)
application.register("website--orders-live", OrdersLiveController)
application.register("website--page-menu", PageMenuController)
application.register("website--payment-form", PaymentFormController)
application.register("website--payment-wait", PaymentWaitController)
application.register("website--pickpost", PickpostController)
application.register("website--popover", PopoverController)
application.register("website--popper", PopperController)
application.register("website--product-buy-box", ProductBuyBoxController)
application.register("website--product-cover", ProductCoverController)
application.register("website--product-description", ProductDescriptionController)
application.register("website--product-gallery", ProductGalleryController)
application.register("website--product-hover", ProductHoverController)
application.register("website--product-page", ProductPageController)
application.register("website--product-share", ProductShareController)
application.register("website--product-thumbnails", ProductThumbnailsController)
application.register("website--quick-shop", QuickShopController)
application.register("website--remote-form", RemoteFormController)
application.register("website--return-slip", ReturnSlipController)
application.register("website--sale-alert", SaleAlertController)
application.register("website--sale-list", SaleListController)
application.register("website--sale-menu", SaleMenuController)
application.register("website--sale-page", SalePageController)
application.register("website--temporary-notice", TemporaryNoticeController)
application.register("website--tooltip", TooltipController)
application.register("website--zendesk", ZendeskController)
